var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQRerrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 103,
    viewBox: "0 0 96 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6609 1.14138e-05L4.00451 6.33148L14.3159 11.5284L13.6609 1.14138e-05ZM94.3021 87.8487C68.5118 105.765 39.7276 103.05 21.3285 87.3949C2.95592 71.7621 -5.27036 43.0302 10.5156 8.46084L8.69636 7.63006C-7.39852 42.8758 0.870564 72.6137 20.0325 88.9182C39.168 105.2 68.9575 107.89 95.4431 89.4912L94.3021 87.8487Z",
    fill: "black",
    fillOpacity: 0.17
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQRerrow);
export default __webpack_public_path__ + "static/media/QRerrow.eb1418971d4f41da279bfe19426ab821.svg";
export { ForwardRef as ReactComponent };